import { render, staticRenderFns } from "./CardAmountDuo.vue?vue&type=template&id=39f06716&"
import script from "./CardAmountDuo.vue?vue&type=script&lang=js&"
export * from "./CardAmountDuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports